import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { generateJoinUrl } from '../../utils/roomCode';

interface QRCodeDisplayProps {
  roomName: string;
  size?: number;
  showLabel?: boolean;
  label?: string;
  containerStyle?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
}

export const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({
  roomName,
  size = 180,
  showLabel = true,
  label = "Scan to join:",
  containerStyle,
  innerStyle,
}) => {
  if (!roomName) {
    return null;
  }
  
  const joinUrl = generateJoinUrl(roomName);

  const defaultContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.8rem',
    padding: '1rem',
    backgroundColor: 'rgba(248, 250, 252, 0.05)',
    borderRadius: '12px',
    border: '2px solid rgba(248, 250, 252, 0.2)',
    ...containerStyle,
  };

  return (
    <div style={defaultContainerStyle}>
      {showLabel && (
        <p style={{
          color: '#fff',
          fontSize: '0.9rem',
          fontWeight: '500',
          margin: 0,
        }}>
          {label}
        </p>
      )}
      <div style={{
        padding: '0.8rem',
        backgroundColor: '#fff',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...innerStyle,
      }}>
        <QRCodeSVG
          value={joinUrl}
          size={size}
          level="H"
          includeMargin={true}
        />
      </div>
    </div>
  );
};
